import { apiCall } from './api';
import { MSQ_ACCREDITATIONS, MSQ_ACCREDITATION_DETAILS, MSQ_ACCREDITATION_STATUS, MSQ_ACCREDITATION_STATS } from '../config/api';

// Get all MSQ Accreditations
export const getMsqAccreditations = async (params = {}) => {
  try {
    console.log('🚀 getMsqAccreditations called with params:', params);
    console.log('🔗 Making API call to:', MSQ_ACCREDITATIONS);
    
    const response = await apiCall(MSQ_ACCREDITATIONS, {
      method: 'GET',
      params
    });
    
    console.log('📡 API Response from getMsqAccreditations:', response);
    return response;
  } catch (error) {
    console.error('❌ Error in getMsqAccreditations:', error);
    throw error;
  }
};

// Get MSQ Accreditation by ID
// Expected API endpoint: GET /api/msq-accreditations/{id}
// Expected response structure:
// {
//   "success": true,
//   "data": {
//     "id": 1,
//     "title": "HTML formatted title",
//     "description": "HTML formatted description", 
//     "status": "active|inactive|pending",
//     "certificate_number": "CERT-001",
//     "video_url": "HTML formatted video content or URL",
//     "created_at": "2024-01-01T00:00:00Z",
//     "updated_at": "2024-01-01T00:00:00Z",
//     "meta": {
//       "tags": ["tag1", "tag2"],
//       "category": "certification",
//       "duration": "2 hours",
//       "difficulty": "intermediate"
//     }
//   }
// }
export const getMsqAccreditationById = async (accreditationId) => {
  try {
    const endpoint = MSQ_ACCREDITATION_DETAILS.replace('{id}', accreditationId);
    console.log('🔍 Fetching accreditation details from:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    
    console.log('📡 API Response from getMsqAccreditationById:', response);
    return response;
  } catch (error) {
    console.error('❌ Error fetching MSQ Accreditation:', error);
    throw error;
  }
};

// Create new MSQ Accreditation
export const createMsqAccreditation = async (accreditationData) => {
  try {
    console.log('🚀 createMsqAccreditation called with data:', accreditationData);
    console.log('🔗 Making API call to:', MSQ_ACCREDITATIONS);
    
    const response = await apiCall(MSQ_ACCREDITATIONS, {
      method: 'POST',
      data: accreditationData
    });
    
    console.log('📡 API Response from createMsqAccreditation:', response);
    return response;
  } catch (error) {
    console.error('❌ Error creating MSQ Accreditation:', error);
    throw error;
  }
};

// Update MSQ Accreditation
export const updateMsqAccreditation = async (accreditationId, accreditationData) => {
  try {
    const endpoint = MSQ_ACCREDITATION_DETAILS.replace('{id}', accreditationId);
    console.log('🚀 updateMsqAccreditation called with ID:', accreditationId, 'and data:', accreditationData);
    console.log('🔗 Making API call to:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: accreditationData
    });
    
    console.log('📡 API Response from updateMsqAccreditation:', response);
    return response;
  } catch (error) {
    console.error('❌ Error updating MSQ Accreditation:', error);
    throw error;
  }
};

// Delete MSQ Accreditation
export const deleteMsqAccreditation = async (accreditationId) => {
  try {
    const endpoint = MSQ_ACCREDITATION_DETAILS.replace('{id}', accreditationId);
    const response = await apiCall(endpoint, {
      method: 'DELETE'
    });
    return response;
  } catch (error) {
    console.error('Error deleting MSQ Accreditation:', error);
    throw error;
  }
};

// Update MSQ Accreditation status
export const updateMsqAccreditationStatus = async (accreditationId, status) => {
  try {
    const endpoint = MSQ_ACCREDITATION_STATUS.replace('{id}', accreditationId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error updating MSQ Accreditation status:', error);
    throw error;
  }
};

// Get MSQ Accreditation statistics
export const getMsqAccreditationStats = async () => {
  try {
    const response = await apiCall(MSQ_ACCREDITATION_STATS, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching MSQ Accreditation stats:', error);
    throw error;
  }
};
